import actions from './actions'
import mutations from './mutations'

const groups = {
    namespaced: true,
    state: {
        groups: [],
        groupStatistic: null,
        businessGroupStatistic: null,
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        clientsCount: null,
        isLoaded: true,
        filters: {
            name: null,
            type: null,
            valuesFrom: null,
            valuesTo: null,
            includeUnallocated: null,
            onlyUnallocated: null,
            accountId: null,
            used: null,
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0], // current date minus month
            toDate: new Date().toISOString().split('T')[0],
            isDelivery: null,
            bonusSystem: null
        }
    },
    mutations,
    actions
}

export default groups
